import { render, staticRenderFns } from "./ram-viewer.vue?vue&type=template&id=03b4431f"
import script from "./ram-viewer.vue?vue&type=script&lang=js"
export * from "./ram-viewer.vue?vue&type=script&lang=js"
import style0 from "./ram-viewer.vue?vue&type=style&index=0&id=03b4431f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports